import {
  COMMISSIONS_GET_INCENTIVE_CARDS_BEGIN,
  COMMISSIONS_GET_INCENTIVE_CARDS_SUCCESS,
  COMMISSIONS_GET_INCENTIVE_CARDS_FAILURE
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
        
    case COMMISSIONS_GET_INCENTIVE_CARDS_BEGIN:
      return {
          ...state,
          policies: {
            ...state.policies,
            listIncentives: [],
            incetiveValues: [
              { price: {} },
              { salesQuantity: {} },
              { takingCar: {} },
              { opportunity: {} },
              { profitability: {} }
            ],
            opportunityIncentiveProduct: [],
            listIncentiveCardsSuccess: false,
          }
      }

    case COMMISSIONS_GET_INCENTIVE_CARDS_SUCCESS:
      return {
          ...state,
          policies: {
            ...state.policies,
            listIncentives: action.result,
            listIncentiveCardsSuccess: true
          }
      }

    case COMMISSIONS_GET_INCENTIVE_CARDS_FAILURE:
      return {
        ...state,
        policies: {
          ...state.policies,
        listIncentiveCardsSuccess: false
      }
    }

    default:
      return state
  }
}
